import { render, staticRenderFns } from "./SalesCalls.vue?vue&type=template&id=4ca30c54&"
import script from "./SalesCalls.vue?vue&type=script&lang=js&"
export * from "./SalesCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports